import { render } from "./PlainText.vue?vue&type=template&id=4bc20b3e"
import script from "./PlainText.vue?vue&type=script&lang=js"
export * from "./PlainText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__